import { __decorate, __metadata } from "tslib";
import { h, Host } from "@stencil/core";
import { BEM } from "../../../utils/bem";
import { Logger } from "../../../utils/log";
import { ListenToResize } from "../../../utils/resize";
import { BalScrollHandler } from "../../../utils/scroll";
export class NavMenuFlyout {
    constructor() {
        this.bodyScrollHandler = new BalScrollHandler();
        this.isHidden = false;
        this.navId = `bal-nav-x${NavMenuFlyOutIds++}`;
    }
    createLogger(log) {
        this.log = log;
    }
    /**
     * LIFECYCLE
     * ------------------------------------------------------
     */
    connectedCallback() {
        this.bodyScrollHandler.connect();
    }
    disconnectedCallback() {
        this.bodyScrollHandler.disconnect();
    }
    /**
     * LISTENERS
     * ------------------------------------------------------
     */
    resizeListener() {
        if (this.isFlyoutScrollable()) {
            this.bodyScrollHandler.disable();
        }
        else {
            this.bodyScrollHandler.enable();
        }
    }
    /**
     * PRIVATE METHODS
     * ------------------------------------------------------
     */
    isFlyoutScrollable() {
        var _a, _b;
        return ((_a = this.el) === null || _a === void 0 ? void 0 : _a.scrollHeight) > ((_b = this.el) === null || _b === void 0 ? void 0 : _b.clientHeight);
    }
    /**
     * RENDER
     * ------------------------------------------------------
     */
    render() {
        const block = BEM.block('nav-menu-flyout');
        const line = block.element('line');
        return (h(Host, { key: 'd2de6257fc31499b2d26204ee0db07a4e079144b', id: `${this.navId}-menu-flyout`, class: Object.assign({}, block.class()) }, h("div", { key: '6392e2be737b3f5c11dd83602f210d1a263c7a5f', class: Object.assign({}, line.class()) }), h("div", { key: 'b6d06ea36310b6ed5975f2bae2f57e65d1e29f82', class: Object.assign({}, block.element('container').class()) }, h("slot", { key: '38566fffa659f0661e3cb7ca7535c6a7f244b696' }))));
    }
    static get is() { return "bal-nav-menu-flyout"; }
    static get originalStyleUrls() {
        return {
            "$": ["bal-nav-menu-flyout.sass"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["bal-nav-menu-flyout.css"]
        };
    }
    static get properties() {
        return {
            "navId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This is used to connect the flyout to the aria controls"
                },
                "getter": false,
                "setter": false,
                "attribute": "nav-id",
                "reflect": false,
                "defaultValue": "`bal-nav-x${NavMenuFlyOutIds++}`"
            }
        };
    }
    static get states() {
        return {
            "isHidden": {}
        };
    }
    static get elementRef() { return "el"; }
}
__decorate([
    Logger('bal-nav-menu-flyout'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], NavMenuFlyout.prototype, "createLogger", null);
__decorate([
    ListenToResize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], NavMenuFlyout.prototype, "resizeListener", null);
let NavMenuFlyOutIds = 0;
